import { FC } from 'react';
// component
import SettingsComponent from 'components/main/Settings';

const Settings: FC = () => <SettingsComponent />;

export default Settings;
